import { createPortal, useEffect, useState } from "preact/compat";
import { JSXInternal } from "preact/src/jsx";
import constants from "../constants";
import designService from "../service/designService";
import Spinner from "./Spinner";

export interface MoveCopyTemplateModal {
  open: boolean;
  onModalClose: () => void;
  selectedDesigns: any[];
  promoDesigns: any[];
  admin: boolean;
  getTemplates: () => void;
}

export default function MoveCopyTemplateModal({open, selectedDesigns, promoDesigns, onModalClose, admin, getTemplates}: MoveCopyTemplateModal) {
    const [status, setStatus] = useState('previous');
    const [loadingMove, setLoadingMove] = useState(false);
    const [loadingCopy, setLoadingCopy] = useState(false);
    
    useEffect(() => {
    }, [selectedDesigns]);

    const statusOptions = constants.statuses.map(status =>
        <option value={status.id} className={!admin && status.forAdmin ? 'hidden' : ''}>{status.label}</option>
    );

    function alignLeft() {
        $('.config-modal').css('margin', '0 auto 0 2%')
      };

    function alignCenter() {
        $('.config-modal').css('margin', '0 auto');
    };

    function alignRight() {
        $('.config-modal').css('margin', '0 2% 0 auto')
    }

    function onStatusChange(ev: JSXInternal.TargetedEvent) {
        let target = ev.target as HTMLSelectElement;
        setStatus(target.value);
    }

    function move() {
        if (loadingCopy || loadingMove) {
            return;
        }
        setLoadingMove(true);
        let loadingCount = selectedDesigns.length;
        selectedDesigns.forEach((des) => {
            designService.getDesign(des.id).then(resp => {
                const data = resp.data;
                let newStatus = status !== "previous" ? status : data.status;
                designService.updateDesign({
                  id: des.id,
                  status: newStatus
                }).then(resp => {
                    if (promoDesigns.length > 0) {
                        const thisDesign = promoDesigns.find(it => it.id === des.id);
                        thisDesign.status = newStatus;
                    }
                    loadingCount--;
                    if (loadingCount <= 0) {
                        setLoadingMove(false);
                        onModalClose();
                    }
                }).catch(err => {
                    console.log("Error moving design");
                    loadingCount--;
                    if (loadingCount <= 0) {
                        setLoadingMove(false);
                        onModalClose();
                    }
                })
              })
        })
    }

    function copy() {
        if (loadingCopy || loadingMove) {
            return;
        }
        setLoadingCopy(true);
        let loadingCount = selectedDesigns.length;
        selectedDesigns.forEach(des => {
            designService.makeCopy(des.id, 'Copy of ' + des.name, des.size, des.width, des.height, des.unit)
            .then(resp => {
                const newDesId = resp.data;
                designService.updateDesign({
                    id: newDesId,
                    status: status === 'previous' ? des.status : status
                }).then(resp => {
                    loadingCount--;
                    if (loadingCount <= 0) {
                        setLoadingCopy(false);
                        getTemplates();
                        onModalClose();
                    }
                }).catch(err => {
                    console.log("Error setting status");
                    loadingCount--;
                    if (loadingCount <= 0) {
                        setLoadingCopy(false);
                        onModalClose();
                    }
                })
            }).catch(err => {
                console.log("Error copying design");
                loadingCount--;
                if (loadingCount <= 0) {
                    setLoadingCopy(false);
                    onModalClose();
                }
            })
        })
    }

    return open ? createPortal(<div>
        <div class="modal-back transparent" onClick={onModalClose}></div>
        <div className="modal config-modal move-copy-modal">
            <a className="close" onClick={onModalClose}>
            <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-close"}/>
            </svg>
            </a>

            <header>
                <h2>Move or Copy Templates</h2>
            </header>

            <div className="aligns" style="display: inline-block; float: right; margin-top: -27px; margin-right: 10px;">
                <a style="cursor: pointer" onClick={alignLeft}>
                    <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-left"}/>
                    </svg>
                </a>
                <a style="cursor: pointer" onClick={alignCenter}>
                    <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-vertical"}/>
                    </svg>
                </a>
                <a style="cursor: pointer" onClick={alignRight}>
                    <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-right"}/>
                    </svg>
                </a>
            </div>

            <div className="form-block">
                <label>Status</label>
                <select value={status} onChange={(ev) => onStatusChange(ev)}>
                    <option value={'previous'}>(Previously Set)</option>
                    {statusOptions}
                </select>
            </div>

            <footer>
                <a className={`btn primary ${loadingMove || loadingCopy ? 'disabled' : ''}`} onClick={move}>
                    {loadingMove && <Spinner/>}
                    {!loadingMove && <span>Move</span>}
                </a>

                <a className={`btn decline ${loadingMove || loadingCopy ? 'disabled' : ''}`} onClick={copy}>
                    {loadingCopy && <Spinner/>}
                    {!loadingCopy && <span>Copy</span>}
                </a>
            </footer>
        </div>  
    </div>, document.getElementById('modals') as HTMLElement) : null;
}
